import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';


const stripePromise = loadStripe('pk_live_51KpWTiJ3LESCIMvinQn8uZP7nqeRoD2jKP5da80kBixCXvrRVOatM4YEvZkcmYKqYhr9lIS2stJSC2sfliWk83ot004L8AKtfZ');  // Replace with your Stripe public key

const StripeWrapper = ({ children }) => {
  return <Elements stripe={stripePromise}>{children}</Elements>;
};

export default StripeWrapper;
